import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { DialogRef, DialogService } from '@ngneat/dialog';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';
import { isMobileView } from '@core/utils';
import { SurveysComposition } from '@shared/compositions';
import { NgSelectModule } from '@ng-select/ng-select';
import { SectionType, SurveyType } from '@core/enums';
import { DatePickerInputComponent, FormErrorComponent } from '@shared/components';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent } from '@shared/components/ui';

@Component({
  selector: 'app-survey-form-create-edit',
  templateUrl: './survey-form.component.html',
  styleUrls: ['./survey-form.component.scss'],
  imports: [ReactiveFormsModule, NgStyle, IconComponent, ButtonComponent, DropdownComponent, TranslateModule, DatePickerInputComponent, FormErrorComponent, NgSelectModule, ImageSelectorComponent],
  providers: [DialogService],
})
export class SurveyFormComponent extends SurveysComposition implements OnInit {
  formSurveyId: any;
  surveyForm: FormGroup;
  protected readonly SurveyType = SurveyType;
  protected readonly isMobileView = isMobileView;
  protected readonly SectionType = SectionType;
  private readonly _elRef = inject(ElementRef);

  constructor() {
    super();
    if (!isMobileView()) {
      this.dialogRef = inject(DialogRef);
      this.formSurveyId = this.dialogRef.data?.id;
    } else {
      this.formSurveyId = this._bottomSheet.currentSheetData?.id;
    }
    this._initForm();
  }

  get isUpdateMode(): boolean {
    return !!(this.currentSurvey && this.currentSurvey?.id && this.currentSurvey?.imageUrl);
  }

  get choices() {
    return this.surveyForm.get('multipleSelection.choices') as FormArray;
  }

  ngOnInit() {
    this._fetchDataForForm();
    this.addAnswer();
    this.addAnswer();

    if (this.formSurveyId) {
      this._fetchSurvey(this.formSurveyId);
    }
  }

  addChoice() {
    this.choices.push(new FormControl(''));
  }

  submit(btnRef?: ButtonComponent) {
    if (this.form.invalid) {
      this.markAllInvalidControlsAndScrollToFirst(this.form, this._elRef);
      return;
    }
    this.save(btnRef);
  }

  closeDialogBox() {
    this.dialogRef?.close();
  }

  closeSheet() {
    this._bottomSheet.close();
  }
}
